import { render, staticRenderFns } from "./Pictogramas.vue?vue&type=template&id=57579c31&scoped=true"
import script from "./Pictogramas.vue?vue&type=script&lang=js"
export * from "./Pictogramas.vue?vue&type=script&lang=js"
import style0 from "./Pictogramas.vue?vue&type=style&index=0&id=57579c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57579c31",
  null
  
)

export default component.exports